
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  toRef,
  watch,
  shallowRef,
  inject,
} from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { ICurrentUser } from "@/interfaces/iCurrentUser";
import { IBulkDelete } from "@/interfaces/iPageModel";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { INNER_PAGE_ROWS_PER_PAGE, usePagination } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import { SiteApi } from "@/services/api/Site.service";
import { UserAPI } from "@/services/api/User.service";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import {
  siteUserTableBulkDelete,
  siteUserTableFilters,
  siteUserTableHeaders,
} from "../siteDataTableOptions";
import { ISite, ISiteUser } from "@/interfaces/iSite";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import { ITabConfig } from "@/interfaces/iTabConfig";
import * as Yup from "yup";
import { USER_TABS } from "@/views/user/dataTableOptions";
import PreviewLink from "@/components/typography/PreviewLink.vue";
import UserDetailModal from "@/views/user/modal/UserDetailModal.vue";
import SiteUserModal from "@/components/modals/forms/AddSiteUserModal.vue";
import { hasPermission } from "@/core/services/permission.service";
import { Modal } from "bootstrap";
import { getLookups } from "@/services/api/Lookup.service";
import AddEditModal from "@/components/modals/forms/AddEditModal.vue";
import { debounce } from "lodash";
export default defineComponent({
  props: {
    data: { type: Object as PropType<ISite>, required: true },
    openDrawer: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
  },
  components: {
    Datatable,
    VZDeleteModal,
    PreviewLink,
    UserDetailModal,
    SiteUserModal,
    AddEditModal,
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const store = useStore();
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });
    const cannotBeUnassign = t("pages.site.users.cannotBeUnassign");
    const dataProp = toRef(props, "data");
    const openDrawer = toRef(props, "openDrawer");
    const { page, total } = usePagination();
    const rowsPerPage = ref(INNER_PAGE_ROWS_PER_PAGE);
    const loading = ref(false);
    const visible = ref(false);
    const showSearch = true;
    const addUserModel = ref<null | HTMLFormElement>(null);
    const showDetailDialog = ref<any>(false);
    const tableData = ref<ISiteUser[]>([]);
    const allTableData = ref<ISiteUser[]>([]);
    const selectedForAction = ref<Partial<ISiteUser>>({});
    const selectedUser = ref<Partial<any>>({});
    const localPreference = ref({});
    const bulkDelete = ref<IBulkDelete>(siteUserTableBulkDelete());
    const tableHeader = ref(siteUserTableHeaders());
    const showDeleteDialog = ref<any>(false);
    const showModalActive = ref(false);
    const showAddSiteRole = ref(false);
    let roleOptions: { label: any; value: string }[] = [];
    const tableFilter = ref(siteUserTableFilters());
    const siteRoleOptions = ref<{ label: string; value: string }[]>();
    const formRef = ref<HTMLFormElement>();
    const loadingUserDetailModal = ref(false);
    const Datatable = ref();
    const refreshSiteList = inject<() => void>("refreshSiteList");
    const closeDrawer = inject<() => void>("closeDrawer");
    const format = computed(() => {
      return FormatMethods;
    });
    const userSiteModelData = ref<IAddEditFormModel>({
      header: "Branches",
      page: "Site",
      edit: false,
      data: null,
      label: [{ addHeader: t("pages.user.assignRole") }],
      validationSchema: Yup.object({
        roleId: Yup.string()
          .nullable()
          .min(1, t("pages.user.role") + " " + t("common.isRequired"))
          .required(t("pages.user.role") + " " + t("common.isRequired")),
      }),
      model: [
        {
          name: "roleId",
          label: t("pages.site.role"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select role",
          options: siteRoleOptions.value ?? [],
        },
      ],
    });
    let siteUserModalData = ref<any>(
      computed(() => {
        return props.data;
      }).value
    );
    let permissionModel = ref<any>({
      create: "VYZOR:BUSINESS:SITE:CREATE",
      delete: "VYZOR:BUSINESS:SITE:DELETE",
      update: "VYZOR:BUSINESS:SITE:UPDATE",
    });
    const tabs = shallowRef<ITabConfig[]>(USER_TABS());
    onMounted(async () => {
      // await refreshList();
      loading.value = true;
      await getLookups(`security/filter/ROLES`)
        .then((res) => {
          res.map((data) => {
            roleOptions.push({
              label: data.text,
              value: data.value,
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    });

    const customForm = () => {
      siteUserModalData.value = { ...props.data };
      visible.value = true;
      // const modal = new Modal(
      //   document.getElementById(`kt_modal_assign_user`) as HTMLElement
      // );
      formRef.value?.resetForm();
      // modal.show();
    };

    const openRoleModal = async (user) => {
      try {
        selectedUser.value = user;
        const data = await getLookups(`security/filter/ROLES`);
        siteRoleOptions.value =
          data?.map((obj) => {
            return {
              label: obj.text,
              value: obj.value,
            };
          }) ?? [];
        showAddSiteRole.value = true;
        const modal = new Modal(
          document.getElementById(
            "vz-add-edit-modal-user_site_modal"
          ) as HTMLElement
        );
        modal.show();
      } catch (e) {
        console.log(e);
      }
    };
    const computedUserSiteModalData = computed(() => {
      return {
        ...userSiteModelData.value,
        model: userSiteModelData.value.model.map((model) => {
          if (model.name === "roleId") {
            return { ...model, options: siteRoleOptions.value ?? [] };
          }
          return model;
        }),
      };
    });
    const submit = async (reqData) => {
      loading.value = true;
      reqData = {
        ...reqData,
        siteId: dataProp.value.webId,
      };
      await SiteApi.getInstance()
        .addSiteUser(reqData, formData.value.edit)
        .then(() => {
          queryUpdate(dataProp.value.webId, { ...localPreference.value });
        })
        .catch(() => {
          //
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(dataProp.value.webId, params);
    };

    const editSite = (item: ISiteUser) => {
      formData.value.data = item;
      formData.value.edit = true;
    };

    let formData = ref<IAddEditFormModel>({
      page: "User Sites",
      header: "User Sites",
      edit: false,
      data: null,
      validationSchema: Yup.object({
        userAccountId: Yup.string().required(
          t("pages.site.user") + " " + t("common.isRequired")
        ),
        roleId: Yup.string().required(
          t("pages.site.role") + " " + t("common.isRequired")
        ),
      }),
      label: [{ addHeader: t("pages.site.assignUser") }],
      model: [
        {
          name: "userAccountId",
          label: t("pages.site.user"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select user",
        },
        {
          name: "roleId",
          label: t("pages.site.role"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          options: roleOptions,
          placeholder: "Please select role",
        },
      ],
    });

    const queryUpdate = async (
      webId: number,
      params?: Record<string, number | string>
    ) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
          };
        }
        const data = await SiteApi.getInstance().getSiteUserList({
          ...params,
          status: "ACTIVE",
          siteId: dataProp.value.webId,
        });
        const allData = await SiteApi.getInstance().getSiteUserList({
          size: 10000,
          status: "ACTIVE",
          siteId: dataProp.value.webId,
        });
        localPreference.value = { ...params };
        tableData.value = [...data.content];
        allTableData.value = [...allData.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
        addUserModel?.value?.getData();
      } finally {
        loading.value = false;
      }
    };
    const submitSiteRole = async (reqData) => {
      try {
        showAddSiteRole.value = false;
        const payload = {
          roleId: +reqData.roleId || 0,
          userAccountId: selectedUser.value.userAccountId,
          siteId: selectedUser.value.siteId,
        };
        await SiteApi.getInstance().addUserSiteRole(payload);
        refreshList();
      } catch (e) {
        console.log(e);
      }
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
    };
    const openDetailModal = async (site) => {
      showDetailDialog.value = true;
      try {
        loadingUserDetailModal.value = true;
        const user = await UserAPI.getInstance().getUser(site.userAccountId);
        selectedUser.value = user;
      } finally {
        loadingUserDetailModal.value = false;
      }
    };
    const roles =
      currentUser.value?.currentUserSite?.map((role) => role.roleName) || [];
    const isAdmin = roles.includes("Admin");

    const openDeleteDialog = (user) => {
      const isCurrentUser = currentUser.value?.webId === user.userAccountId;

      if (
        !isAdmin &&
        currentUser.value?.currentUserSite?.length === 1 &&
        isCurrentUser
      ) {
        toast.error(cannotBeUnassign);
      } else {
        selectedForAction.value = user;
        showDeleteDialog.value = true;
      }
    };
    const onDelete = () => {
      store.dispatch("updateUser");
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
      refreshSiteList?.();
    };
    const webId = computed(() => props.data?.webId);
    let lastFetchedWebId = null;

    const debouncedQueryUpdate = debounce(async (webId) => {
      if (webId !== lastFetchedWebId) {
        tableData.value = [];
        allTableData.value = [];

        rowsPerPage.value = INNER_PAGE_ROWS_PER_PAGE;
        queryUpdate(+webId, {
          page: page.value - 1,
          size: rowsPerPage.value,
        });
        if (Datatable.value.VZFilter) {
          Datatable.value.VZFilter.getSavedFilterList();
        }
      }
    }, 300);

    watch(
      () => props.isActive,
      async (isActive) => {
        if (isActive && dataProp.value.webId) {
          // await queryUpdate(dataProp.value.webId, {
          //   page: page.value - 1,
          //   size: rowsPerPage.value,
          // });
          loading.value = true;
          if (Datatable.value?.VZFilter) {
            await Datatable.value.VZFilter.getAppliedFilters();
          }
        } else {
          tableData.value = [];
          allTableData.value = [];
        }
      }
    );
    const getClass = (role) => {
      let className = "bg-success";
      if (role == "Manager") {
        className = "bg-info";
      } else if (role == "User") {
        className = "bg-primary";
      } else if (role == "Admin") {
        className = "bg-success";
      }
      return className;
    };
    return {
      currentUser,
      bulkDelete,
      format,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      page,
      total,
      rowsPerPage,
      loading,
      selectedForAction,
      syncQuery,
      refreshList,
      formData,
      editSite,
      submit,
      t,
      openDetailModal,
      submitSiteRole,
      tabs,
      showModalActive,
      getClass,
      selectedUser,
      customForm,
      showAddSiteRole,
      siteUserModalData,
      permissionModel,
      openRoleModal,
      computedUserSiteModalData,
      hasPermission,
      loadingUserDetailModal,
      visible,
      showDeleteDialog,
      showDetailDialog,
      Datatable,
      addUserModel,
      allTableData,
      openDeleteDialog,
      onDelete,
    };
  },
});
